<template>
    <div>
        <Title title="免费" :logo="true" :tablist="tab_list" :tabactive="tab_active" @titleTabActive="titleTabActive"/>

<!--        <div class="fxboex head">-->
<!--            <div class="logo"><router-link to="/"/></div>-->
<!--            <div class="head_nav">-->
<!--                <van-tabs v-model="tab_active">-->
<!--                    <van-tab v-for="(c, i) in tab_list" :key="i" :title="c"/>-->
<!--                </van-tabs>-->
<!--            </div>-->
<!--        </div>-->

        <div class="page-loading" v-if="isInit === true">
            <van-skeleton title :row="8" />
        </div>
        <template v-else>
<!--            <van-pull-refresh v-model="isRefresh" @refresh="onRefresh">-->

            <template v-if="tab_active===0">
                <match_mini :data="match_list[0]"/>
                <match_dan_his :data="match_dan_his" :url="links.football_dan"/>
                <match_mini :data="match_list[1]"/>
            </template>
            <template v-else-if="tab_active===1">
                <match_mini :data="match_list[3]"/>
                <match_dan_his :data="match_dan_bk_his" :url="links.baskball_dan"/>
                <match_mini :data="match_list[4]"/>
            </template>

<!--            <div class="free_tm free_tm2">优惠券<router-link to="/coupon">优惠说明</router-link></div>-->
<!--            <div class="coupon coupon_m">-->
<!--                <swiper :options="focusSwiperOption" ref="couponSwiper">-->
<!--                    <swiper-slide v-for="(m,i) in coupon_list" :key="i">-->
<!--                        <div :class="m.is_get === true?'item itemdis':'item couponget'" @click="getCoupon(m.id, i)">-->
<!--                            <div class="amt">{{ m.amt }}<span>FXB</span></div>-->
<!--                            <div class="name">{{ m.name }}</div>-->
<!--                            <div class="time">有效期至 /&nbsp;&nbsp;&nbsp;{{ m.end_time }}</div>-->
<!--                            <div class="tag" v-if="m.is_get">已领取</div>-->
<!--                            <div class="tag" v-else>领</div>-->
<!--                        </div>-->
<!--                    </swiper-slide>-->
<!--                </swiper>-->
<!--            </div>-->

<!--            <div class="freepanel" v-if="tab_active===0">-->
<!--                <div class="free_tm">专家预测</div>-->
<!--                <match_mini :data="match_list[2]"/>-->
<!--                <div class="panel_more panel_more_zj"><router-link to="/football">更多专家预测 &gt;</router-link></div>-->
<!--            </div>-->
<!--                            -->
<!--            <div class="freepanel" v-else-if="tab_active===1">-->
<!--                <div class="free_tm">专家预测</div>-->
<!--                <match_mini :data="match_list[5]"/>-->
<!--                <div class="panel_more panel_more_zj"><router-link to="/baskball">更多专家预测 &gt;</router-link></div>-->
<!--            </div>-->

<!--            </van-pull-refresh>-->

        </template>

    </div>
</template>

<script>
    import match_mini from './public/match_mini'
    import match_dan_his from './public/match_dan_his'
    import Title from './public/title'
    // import coupon_mini from './public/coupon_mini'
    export default {
        name: "help",
        components: {
            match_mini,
            match_dan_his,
            Title,
            // coupon_mini,
        },
        data() {
            return {
                links: {
                    football: '/football',
                    baskball: '/baskball',
                    football_dan: '/football/dan',
                    baskball_dan: '/baskball/dan',
                },
                match_dan_his: null,
                match_dan_bk_his: null,
                match_list: [
                    {'type': 1, 'list': []}, //match_dan
                    {'type': 2, 'list': []}, //match_free
                    {'type': 3, 'list': []}, //match_football
                    {'type': 1, 'list': []}, //match_dan_bk
                    {'type': 2, 'list': []}, //match_free_bk
                    {'type': 3, 'list': []}, //match_baskball
                ],

                tab_list: ['足球', '篮球'],
                tab_active: 0,

                timer: null,
                isInit: true,
                isRefresh: false,

                // coupon_list: [],
                // focusSwiperOption: {
                //     slidesPerView: 2,
                //     spaceBetween: 8,
                //     autoplay: {
                //         delay: 5000,
                //         disableOnInteraction: false
                //     },
                //     loop: true,
                //     loopFillGroupWithBlank: true,
                // }
            }
        },
        watch: {
            // '$route': {
            //     handler () {
            //         // this.getData()
            //         document.documentElement.scrollTop = this.$route.meta.y
            //     }
            // }
        },
        activated() {
            // this.$backTop()
            this.getData()
        },
        beforeDestroy() {

        },
        /**
         * 页面初始化完操作
         * @type {default}
         */
        mounted() {

        },
        methods: {
            swipeChange(i){
              // console.log(i)
                this.tab_active = i
            },
            onRefresh(){
                let that = this
                this.page = 1
                setTimeout(function () {
                    that.getData()
                }, 200)
            },
            titleTabActive(v){
                // console.log(v)
                this.tab_active = v
                this.$backTop()
                // this.$refs.swiper.swipeTo(v)
            },
            getData(){
                let that = this
                that.$get(that.$api.free,{})
                    .then(function (res) {
                        if(res.code === 1) {
                            that.match_dan_his = res.data.match_dan_his
                            that.match_dan_bk_his = res.data.match_dan_bk_his

                            that.match_list[0].list = res.data.match_dan
                            that.match_list[1].list = res.data.match_free
                            // that.match_list[2].list = res.data.match_football
                            that.match_list[3].list = res.data.match_dan_bk
                            that.match_list[4].list = res.data.match_free_bk
                            // that.match_list[5].list = res.data.match_baskball
                            // that.coupon_list = res.data.coupon

                            that.isInit = false
                        }
                    })
                    .finally(function () {
                        that.isRefresh = false
                    })
            },
            // getCoupon(id, i){
            //     let that = this
            //     let item = that.coupon_list[i]
            //     if(item.is_get) return
            //     that.$post(that.$api.getCoupon, {cid: id}).then(function (res) {
            //         if(res.code === 1){
            //             that.$toast.success(res.msg)
            //         }
            //         else if(res.code === 2){
            //             that.$toast.fail(res.msg)
            //             item.is_get = true
            //         }
            //         else
            //             that.$toast.fail(res.msg)
            //     })
            // }
        },
        // beforeRouteEnter(to, from, next){
        //     next(vm =>{
        //         document.documentElement.scrollTop = vm.$route.meta.y
        //     })
        // }
    }
</script>

<style scoped>
    .van-swipe{height: calc(100vh - 100px);}
    .van-swipe-item{overflow-y: auto;}
</style>
